import { render, staticRenderFns } from "./warnings-list.component.vue?vue&type=template&id=62cd9aa0"
import script from "./warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports